import { subscriptionFragment } from '@/services/fragments/subscriptionFragment'

export const createOrgMemberMtn = /* GraphQL */ `
  mutation CreateOrganizationMember($input: CreateOrganizationMemberInput!) {
    createOrganizationMember(input: $input) {
      createdAt
    }
  }
`
export const assignSeatMutation = /* GraphQL */ `
  mutation AssignSeat($input: AssignSeatInputInput!) {
    assignSeat(input: $input) {
      id
      organizationID
      status
      onSeat
      seatAccessState
      seatAccessReason
    }
  }
`
export const reassignSeatMutation = /* GraphQL */ `
  mutation ReassignSeat($input: ReassignSeatInputInput!) {
    reassignSeat(input: $input) {
      source {
        id
        userID
        organizationID
        status
        role
        onSeat
        seatAccessState
        seatAccessReason
      }
      target {
        id
        userID
        organizationID
        status
        role
        onSeat
        seatAccessState
        seatAccessReason
      }
    }
  }
`
export const getOrganizationSummaryQuery = /* GraphQL */ `
  query GetOrganizationSummary($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      tagline
      legal
      color
      status
      template
      logo
      SIRET
      VAT
      email
      phone
      address
      zipcode
      city
      country
      quoteSettings {
        prefix
        startNumber
        defaultValidityDays
        defaultTaxRate
        defaultTerms
        footerText
        logo
        template
      }
      generateSummary
      languages
      partner
      isMaster
      parentID
      masterID
      createdAt
      properties {
        items {
          id
        }
      }
      shops {
        items {
          id
          enabled
          enablePassword
        }
      }
      subscriptions(sortDirection: DESC, limit: 25) {
        items {
          ...subscriptionData
        }
      }
      master {
        id
        name
        color
        logo
        partner
        languages
        properties {
          items {
            id
          }
        }
        shops {
          items {
            id
            enabled
            enablePassword
          }
        }
      }
      parent {
        id
        name
        color
        logo
        partner
        languages
        properties {
          items {
            id
          }
        }
        shops {
          items {
            id
            enabled
            enablePassword
          }
        }
      }
    }
  }
  ${subscriptionFragment}
`

export const getOrganizationMetadataQuery = /* GraphQL */ `
  query GetOrganizationMetadata($id: ID!) {
    getOrganization(id: $id) {
      id
      metadata {
        key
        type
        value
      }
    }
  }
`

export const getOrganizationMembersQuery = /* GraphQL */ `
  query GetOrganizationMembers($id: ID!, $nextToken: String) {
    getOrganization(id: $id) {
      id
      members(
        limit: 100000
        nextToken: $nextToken
        filter: {
          and: [
            { type: { ne: "PROJECT" } }
            { status: { ne: "DECLINED" } }
            { status: { ne: "ARCHIVED" } }
          ]
        }
      ) {
        items {
          id
          userID
          organizationID
          projectID
          status
          onSeat
          seatAccessState
          seatAccessReason
          seatGraceStartedAt
          seatGraceEndsAt
          seatLicenseOrganizationID
          role
          email
          invitationDetails
          member {
            email
            name
          }
          organization {
            id
            name
            color
            isMaster
          }
          type
          updatedAt
          shopManager
        }
        nextToken
      }
    }
  }
`

export const getOrganizationTreeQuery = /* GraphQL */ `
  query GetAuthorizedOrganizationTree($organizationID: ID!) {
    getAuthorizedOrganizationTree(organizationID: $organizationID) {
      organizations {
        id
        name
        parentID
        masterID
        partner
        color
        logo
        isMaster
        members {
          id
          userID
          organizationID
          role
          status
          type
          name
          email
        }
      }
    }
  }
`

export const getOrganizationQuery = getOrganizationTreeQuery

export const updateOrganizationMemberMutation = /* GraphQL */ `
  mutation UpdateOrganizationMember($input: UpdateOrganizationMemberInput!) {
    updateOrganizationMember(input: $input) {
      id
      organizationID
    }
  }
`

export const acceptOrganizationInvitationMutation = /* GraphQL */ `
  mutation AcceptOrganizationInvitation(
    $input: AcceptOrganizationInvitationInputInput!
  ) {
    acceptOrganizationInvitation(input: $input) {
      id
      organizationID
      status
      onSeat
      seatAccessState
      seatAccessReason
      seatGraceStartedAt
      seatGraceEndsAt
      seatLicenseOrganizationID
    }
  }
`

export const createOrganizationMutation = /* GraphQL */ `
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      createdAt
    }
  }
`

export const updateOrganizationMutation = /* GraphQL */ `
  mutation UpdateOrganization($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      updatedAt
    }
  }
`

export const getOrganizationMembersbyProjectIDQuery = /* GraphQL */ `
  query OrganizationMembersbyProjectID($projectID: ID!, $nextToken: String) {
    organizationMembersbyProjectID(
      projectID: $projectID
      limit: 1000
      nextToken: $nextToken
      filter: { and: [{ type: { eq: "PROJECT" } }, { status: { eq: "DONE" } }] }
    ) {
      items {
        shopManager
        userID
        status
        type
      }
      nextToken
    }
  }
`
